(() => {
  const PRODUCT_HANDLE = 'start-met-ontwerpen';
  const BLANK_TEXT = 'Blanco T-shirt kopen';

  const SHAILO_INTRO_VIDEO =
    'https://cdn.shopify.com/videos/c/o/v/9ef6c1bddea84a23a2a776004726461f.mp4';

  let updateBusy = false;
  let introVisible = false;
  let dismissCleanup = null;

  const isCorrectProduct = () => {
    return window.location.pathname.includes(`/products/${PRODUCT_HANDLE}`);
  };

  const getProductSection = () => {
    return (
      document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('.product__info-container')
    );
  };

  const getSelectedPrinting = (productSection) => {
    if (!productSection) return '';

    const selected = [...productSection.querySelectorAll('input[type="radio"]:checked')]
      .find((input) => {
        const name = (input.name || '').toLowerCase();
        const value = (input.value || '').toLowerCase();

        return (
          name.includes('bedrukking') ||
          value.includes('blanco t-shirt') ||
          value === 't-shirt bedrukken'
        );
      });

    return selected ? selected.value.trim() : '';
  };

  const findButtons = (productSection) => {
    const cartButton =
      productSection?.querySelector('.shailo-blank-button') ||
      productSection?.querySelector('button[name="add"]');

    const designerButton =
      document.querySelector('.setupbridgeProductDesigner .btnCustomization') ||
      [...document.querySelectorAll('button')].find((button) =>
        button.textContent.trim().toLowerCase().includes('start met ontwerpen')
      );

    return { cartButton, designerButton };
  };

  const restoreCartButtonText = (cartButton) => {
    if (!cartButton || cartButton.disabled) return;

    const span = cartButton.querySelector('span');

    if (span) {
      span.textContent = BLANK_TEXT;
    } else {
      cartButton.textContent = BLANK_TEXT;
    }
  };

  const updateHeroText = (selectedPrinting) => {
    const intro = document.querySelector('.shailo-studio-intro');
    const heading = intro?.querySelector('.shailo-studio-intro__heading');
    const subheading = intro?.querySelector('.shailo-studio-intro__subheading');

    if (!intro || !heading || !subheading) return;

    const printedHeading = intro.dataset.shailoPrintedHeading || '';
    const printedSubheading = intro.dataset.shailoPrintedSubheading || '';
    const blankHeading = intro.dataset.shailoBlankHeading || '';
    const blankSubheading = intro.dataset.shailoBlankSubheading || '';

    if (selectedPrinting.includes('Blanco T-shirt')) {
      heading.textContent = blankHeading;
      subheading.innerHTML = blankSubheading;
    } else if (selectedPrinting === 'T-shirt bedrukken') {
      heading.textContent = printedHeading;
      subheading.innerHTML = printedSubheading;
    }
  };

  const updateButtons = () => {
    if (!isCorrectProduct() || updateBusy) return;

    const productSection = getProductSection();
    if (!productSection) return;

    const selectedPrinting = getSelectedPrinting(productSection);
    if (!selectedPrinting) return;

    const { cartButton, designerButton } = findButtons(productSection);

    updateBusy = true;

    updateHeroText(selectedPrinting);

    const blank = selectedPrinting.includes('Blanco T-shirt');
    const printed = selectedPrinting === 'T-shirt bedrukken';

    if (blank) {
      if (designerButton) {
        designerButton.style.setProperty('display', 'none', 'important');
        designerButton.setAttribute('aria-hidden', 'true');
      }

      if (cartButton) {
        cartButton.style.removeProperty('display');
        cartButton.removeAttribute('hidden');
        cartButton.removeAttribute('aria-hidden');
        restoreCartButtonText(cartButton);
      }
    } else if (printed) {
      if (cartButton) {
        cartButton.style.setProperty('display', 'none', 'important');
        cartButton.setAttribute('aria-hidden', 'true');
      }

      if (designerButton) {
        designerButton.style.removeProperty('display');
        designerButton.removeAttribute('hidden');
        designerButton.removeAttribute('aria-hidden');
      }
    }

    window.setTimeout(() => {
      updateBusy = false;
    }, 50);
  };

  const scheduleButtonUpdate = () => {
    [0, 100, 300, 700].forEach((delay) => {
      window.setTimeout(updateButtons, delay);
    });
  };

  /* =========================================================
     VIDEO INTRO
     Alleen wanneer de keuze "T-shirt bedrukken" wordt aangeklikt.
     De knop "Start met ontwerpen" wordt NIET onderschept.
  ========================================================= */

  const ensureVideoStyles = () => {
    if (document.getElementById('ShailoVideoIntroStyles')) return;

    const style = document.createElement('style');
    style.id = 'ShailoVideoIntroStyles';

    style.textContent = `
      .shailo-video-intro-overlay {
        position: relative;
        display: none;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin: 14px auto 0;
        z-index: 40;
        pointer-events: none;
      }

      .shailo-video-intro-overlay.is-visible {
        display: flex;
      }

      .shailo-video-intro-circle {
        width: clamp(180px, 27vw, 330px);
        aspect-ratio: 1;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        background: #050505;
        border: 2px solid rgba(229, 189, 85, .72);
        box-shadow:
          0 0 0 1px rgba(255,255,255,.06),
          0 0 18px rgba(229,189,85,.26),
          0 0 42px rgba(229,189,85,.13);
      }

      .shailo-video-intro-circle video {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
        object-position: center;
      }

      @media (max-width: 749px) {
        .shailo-video-intro-circle {
          width: min(64vw, 260px);
        }
      }
    `;

    document.head.appendChild(style);
  };

  const getMediaArea = () => {
    return (
      document.querySelector('.product__media-wrapper') ||
      document.querySelector('.product__media-gallery')
    );
  };

  const createVideoIntro = () => {
    ensureVideoStyles();

    const mediaArea = getMediaArea();
    if (!mediaArea) return null;

    let overlay = mediaArea.querySelector('.shailo-video-intro-overlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'shailo-video-intro-overlay';

    const circle = document.createElement('div');
    circle.className = 'shailo-video-intro-circle';

    const video = document.createElement('video');
    video.src = SHAILO_INTRO_VIDEO;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    circle.appendChild(video);
    overlay.appendChild(circle);
    mediaArea.appendChild(overlay);

    return overlay;
  };

  const removeDismissListeners = () => {
    if (typeof dismissCleanup === 'function') {
      dismissCleanup();
      dismissCleanup = null;
    }
  };

  const hideVideoIntro = () => {
    const overlay = document.querySelector('.shailo-video-intro-overlay');
    const video = overlay?.querySelector('video');

    removeDismissListeners();

    if (overlay) {
      overlay.classList.remove('is-visible');
    }

    if (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_) {}
    }

    introVisible = false;
  };

  const installDismissListeners = () => {
    removeDismissListeners();

    const dismiss = () => {
      if (!introVisible) return;
      hideVideoIntro();
    };

    const passive = { passive: true };

    window.addEventListener('pointerdown', dismiss, passive);
    window.addEventListener('mousemove', dismiss, passive);
    window.addEventListener('wheel', dismiss, passive);
    window.addEventListener('touchmove', dismiss, passive);
    window.addEventListener('scroll', dismiss, passive);
    window.addEventListener('keydown', dismiss);

    dismissCleanup = () => {
      window.removeEventListener('pointerdown', dismiss, passive);
      window.removeEventListener('mousemove', dismiss, passive);
      window.removeEventListener('wheel', dismiss, passive);
      window.removeEventListener('touchmove', dismiss, passive);
      window.removeEventListener('scroll', dismiss, passive);
      window.removeEventListener('keydown', dismiss);
    };
  };

  const playVideoIntro = () => {
    const overlay = createVideoIntro();
    const video = overlay?.querySelector('video');

    if (!overlay || !video) return;

    if (introVisible) {
      hideVideoIntro();
    }

    introVisible = true;
    overlay.classList.add('is-visible');

    try {
      video.currentTime = 0;
    } catch (_) {}

    window.setTimeout(installDismissListeners, 120);

    video.onended = hideVideoIntro;
    video.onerror = hideVideoIntro;

    const promise = video.play();
    if (promise) {
      promise.catch(hideVideoIntro);
    }
  };

  /* =========================================================
     KLIKLOGICA
  ========================================================= */

  document.addEventListener(
    'click',
    (event) => {
      if (!isCorrectProduct()) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const printingLabel = target.closest('label[for]');

      if (
        printingLabel &&
        printingLabel.textContent
          .trim()
          .toLowerCase()
          .includes('t-shirt bedrukken') &&
        !printingLabel.textContent
          .trim()
          .toLowerCase()
          .includes('blanco')
      ) {
        window.setTimeout(playVideoIntro, 80);
      }
    },
    true
  );

  document.addEventListener('change', (event) => {
    if (!isCorrectProduct()) return;

    if (event.target.matches('input[type="radio"], select')) {
      scheduleButtonUpdate();
    }
  });

  document.addEventListener('shopify:section:load', scheduleButtonUpdate);

  const start = () => {
    if (!isCorrectProduct()) return;

    /*
      Eén normale initialisatie bij het openen van de productpagina.
      De zware MutationObserver op de volledige document.body is bewust
      verwijderd, zodat header, apps, afbeeldingen en andere Shopify-
      onderdelen deze T-shirtlogica niet eindeloos opnieuw triggeren.
    */
    scheduleButtonUpdate();

    /*
      Eén extra nacontrole nadat Shopify / SetupBridge tijd heeft gehad
      om te laden. Dit vervangt de permanente body-observer.
    */
    window.setTimeout(() => {
      scheduleButtonUpdate();
    }, 1200);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();